import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
import { tokenNotExpired } from 'angular2-jwt';

@Injectable()
export class AuthService {

  constructor(private jwtHelper: JwtHelper) { }

  public isAuthenticated(): boolean {
    return tokenNotExpired();
  }

  public decodeToken() {
    if (this.isAuthenticated()) {
      return this.jwtHelper.decodeToken(localStorage.getItem('token'));
    }

  }

}


// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/auth/auth.service.ts